module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_maedori_01-8d1025180e60309c53f7374456f27a94.webp";